import React from "react";
import { useLocation } from "react-router-dom";
import TicketDetailCard from "./it-support/TicketDetailCard";

const ViewTicketDetail = () => {
    const { state } = useLocation();

    const ticket = state?.ticket; 

    return (
        <div className="max-w-6xl mx-auto">
            {ticket ? (
                <TicketDetailCard ticket={ticket} mode="view" ticketId={ticket?.tic_id}/>
            ) : (
                <p className="text-center text-red-500 mt-6">Ticket not found.</p>
            )}
        </div>
    );
};

export default ViewTicketDetail;
